import { ToastService } from 'src/app/modules/core/services/toast.service';
import {Injectable, Injector} from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import {from, Observable, throwError} from 'rxjs';
import {AuthenticationService} from '../services/authentication.service';
import {switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {TeamService} from '../services/team.service';
import { ToastMsg } from '../models/ngprime/toastMsg';
import { PortalBootstrapService } from '../services/portal-bootstrap.service';
import { Auth0ClientService } from '../services/auth0-client.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	// Dependencies are resolved lazily through the Injector instead of being
	// constructor-injected. AuthenticationService, Auth0ClientService and
	// PortalBootstrapService all depend (transitively) on HttpClient, which depends on
	// HTTP_INTERCEPTORS — constructor-injecting them puts this interceptor in the eager DI
	// graph and creates a cycle that breaks the HttpClient-using APP_INITIALIZER at bootstrap.
	constructor(private injector: Injector) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.url.indexOf('i18n') > -1) {
			return next.handle(request);
		}

		const portalBootstrap = this.injector.get(PortalBootstrapService);

		if (portalBootstrap.auth0Enabled) {
			const auth0Client = this.injector.get(Auth0ClientService);
			return from(auth0Client.isAuthenticated()).pipe(
				switchMap(isAuthenticated => {
					if (!isAuthenticated) {
						return next.handle(request);
					}
					return from(auth0Client.getAccessTokenSilently()).pipe(
						switchMap(token => {
							request = request.clone({
								setHeaders: { Authorization: `Bearer ${token}` }
							});
							return next.handle(request);
						})
					);
				})
			);
		}

		const auth = this.injector.get(AuthenticationService);

		return auth.getAuthData()
			.pipe(switchMap(r => {
				var url = request.url.toLowerCase();
				if (r.isLoggedIn) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${r.token}`
						}
					});
				} else if (!url.includes('identity/customer/login')
					&& !url.includes('ticketing/clientprinting/')
					&& !url.includes('ticketing/portals/getcustomerpublicportalsettings')
					&& !url.includes('identity/customer/validateprofile')
					&& !url.includes('addresses/getcountries')
					&& !url.includes('addresses/getaddresses')
					&& !url.includes('customer/isnationalidtaken')
					&& !url.includes('customer/isemailtaken')
					&& !url.includes('identitymanagement/customer/registration')
					&& !url.includes('identity/customer/forgotpassword')
					&& !url.includes('identity/customer/checkforgotpasswordtoken')
					&& !url.includes('identity/customer/changepasswordviatoken')
					&& !url.includes('identity/customer/validatelink')
					&& !url.includes('teams/getsponsors')
					&& !url.includes('teams/getteamssocialmedia')
					&& !url.includes('identity/customer/validatelink')
					&& !url.includes('assets/styles/')
					&& !url.includes('identity/customer/setpassword')) {

					const toastService = this.injector.get(ToastService);
					const router = this.injector.get(Router);
					const teamService = this.injector.get(TeamService);

					toastService.showError(new ToastMsg({ detail: 'Unauthorized access you will be redirected to login page.' }));
					setTimeout(() => {
						auth.logout();
						router.navigate([`/${teamService.teamTemplate.teamId}/login`]);
					}, 1000);
					return throwError('Invalid or missing Token.');
				}
				return next.handle(request);
			}));
	}
}
